import React from 'react';
import { useRecord } from '../../../services/deepstream';
import { useCurrentBoard } from '../../../services/state';
import Tooltip from '../../common/Tooltip';

const UserBadge = ({ userId }) => {
  const { id: boardId } = useCurrentBoard();
  const { email, color } = useRecord(`board/${boardId}/user/${userId}`);

  return (
    <Tooltip title={email} placement="left">
      <div className="userBlock" style={{ color, borderColor: color }}>
        <span>{email ? email.charAt(0) : null}</span>
      </div>
    </Tooltip>
  );
};

export default UserBadge;
